// Vue-i18n setup with localStorage persistence and Arco locale binding.
//
// Default locale is zh-CN (Chinese mainland) since cdnX's primary market is
// PRC. The user picks via the dropdown in App.vue's header; their choice is
// written to localStorage('cdnx_locale') and survives reload.
import { createI18n } from 'vue-i18n'
import zhCN from './locales/zh-CN'
import enUS from './locales/en-US'

export type SupportedLocale = 'zh-CN' | 'en-US'

export const LOCALE_STORAGE_KEY = 'cdnx_locale'

function resolveInitialLocale(): SupportedLocale {
  const saved = (typeof localStorage !== 'undefined'
    ? localStorage.getItem(LOCALE_STORAGE_KEY)
    : null) as SupportedLocale | null
  if (saved === 'zh-CN' || saved === 'en-US') return saved
  // Fall back to browser language; anything non-EN gets zh-CN.
  if (typeof navigator !== 'undefined' && navigator.language) {
    if (/^en\b/i.test(navigator.language)) return 'en-US'
  }
  return 'zh-CN'
}

export const i18n = createI18n({
  legacy: false, // use Composition API ($t & useI18n)
  globalInjection: true,
  locale: resolveInitialLocale(),
  fallbackLocale: 'en-US',
  messages: {
    'zh-CN': zhCN,
    'en-US': enUS,
  },
  // Per-locale missing-key warnings flood the console in production; keep
  // them on in dev only.
  missingWarn: import.meta.env.DEV,
  fallbackWarn: import.meta.env.DEV,
})

// Setter used by the language switcher; also updates <html lang> for a11y.
export function setLocale(loc: SupportedLocale) {
  i18n.global.locale.value = loc
  localStorage.setItem(LOCALE_STORAGE_KEY, loc)
  if (typeof document !== 'undefined') {
    document.documentElement.lang = loc
  }
}
